(() => {
  function init(root) {
    const carousel = root.querySelector('[data-hc-carousel]');
    if (!carousel || carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    const slides = [...carousel.querySelectorAll('[data-hc-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hc-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    let hovered = false;
    let focused = false;
    let onScreen = true;
    const pause = carousel.querySelector('[data-hc-pause]');
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        slide.inert = i !== index;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    const restart = () => {
      clearInterval(timer);
      if (pause) {
        pause.textContent = paused ? 'Afspelen' : 'Pauzeren';
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
      }
      if (!paused && !hovered && !focused && onScreen && !document.hidden) timer = setInterval(() => show(index + 1), 6500);
    };
    carousel.querySelector('[data-hc-prev]')?.addEventListener('click', () => { show(index - 1); restart(); });
    carousel.querySelector('[data-hc-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restart(); }));
    pause?.addEventListener('click', () => { paused = !paused; restart(); });
    carousel.addEventListener('mouseenter', () => { hovered = true; restart(); });
    carousel.addEventListener('mouseleave', () => { hovered = false; restart(); });
    carousel.addEventListener('focusin', () => { focused = true; restart(); });
    carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); restart(); });
    carousel.addEventListener('keydown', event => {
      if (event.target.closest('.hc-hero__controls') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        show(index + (event.key === 'ArrowLeft' ? -1 : 1));
        restart();
      }
    });
    document.addEventListener('visibilitychange', restart);
    motion.addEventListener('change', event => { paused = event.matches; restart(); });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { onScreen = entries[0].isIntersecting; restart(); });
      observer.observe(carousel);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) { observer.disconnect(); clearInterval(timer); }
      });
    }
    show(0);
    restart();
  }
  document.querySelectorAll('.hc-home').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hc-home').forEach(init));
})();
